import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_2 = { class: "flex items-center justify-end mt-6" }
const _hoisted_3 = {
  key: 0,
  class: "mt-6 mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_report_list_item = _resolveComponent("report-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { title: "Сгенерировать отчет" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_select, {
        value: _ctx.state.delivery_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.delivery_id) = $event)),
        placeholder: "Выберите Лист ожидания",
        loading: _ctx.data_state.delivery.is_loading,
        options: _ctx.data_state.delivery.list,
        failed: _ctx.data_state.delivery.is_failed,
        "is-invalid": _ctx.state_form$.delivery_id.$error,
        "error-text": "При получении списка файлов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _ctx.refreshDelivery,
        onLoadmore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMoreDelivery(_ctx.data_state.delivery.pagination.current_page + 1))),
        class: "mt-3"
      }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "onRefresh"]),
      _createVNode(_component_the_select, {
        value: _ctx.state.telephony_id,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.telephony_id) = $event)),
        placeholder: "Выберите Телефонию",
        loading: _ctx.data_state.telephony.is_loading,
        options: _ctx.data_state.telephony.list,
        failed: _ctx.data_state.telephony.is_failed,
        "is-invalid": _ctx.state_form$.telephony_id.$error,
        "error-text": "При получении списка файлов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _ctx.refreshTelephony,
        onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreTelephony(_ctx.data_state.telephony.pagination.current_page + 1))),
        class: "mt-3"
      }, null, 8, ["value", "loading", "options", "failed", "is-invalid", "onRefresh"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.state.is_loading,
          onClick: _ctx.getReport
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сгенерировать отчет ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    (_ctx.state.is_report_ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_page_title, {
            title: "Сгенерированный отчет",
            class: "mb-3"
          }),
          _createVNode(_component_list, {
            items: _ctx.state.report,
            onChangePage: _ctx.loadFilesHistory
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_report_list_item, { item: item }, null, 8, ["item"])
            ]),
            _: 1
          }, 8, ["items", "onChangePage"])
        ]))
      : _createCommentVNode("", true)
  ]))
}